'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 10,
    bottom: 50,
    left: 50,
    right: 30
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    xNumberOfTicks: 9,
    yNumberOfTicks: 5,
    yAxisShift: 0,
    xAxisLabelShift: 45,
    yAxisLabelShift: 40
  };
};
module.exports = Params;